import { Listbox } from '@headlessui/react';
import type { NewBillingCycle } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import cn from 'classnames';
import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorLabel } from '../../../components/design/ErrorLabel';
import { ArrowIcon } from '../../../components/icons/ArrowIcon';
import { ARROW_ICON_DIRECTIONS } from '../../../components/icons/ArrowIcon/types/arrow-icon-direction';
import { billingDayOptions } from '../billing-cycle-consts/billing-day-options';

export const BillingDayDropdown = () => {
  const { setValue, watch, formState: { errors } } = useFormContext<NewBillingCycle>();

  const errorMessage = errors.billingDay?.message;
  const hasError = isNotNullOrUndefined(errorMessage);

  return (
    <div className="min-w-[317px]">
      <label className="flex justify-between">
        <span className='text-label text-sm'>Billing Day</span>
      </label>

      <Listbox
        as="div"
        className="rounded-2lg bg-input relative mt-2"
        onChange={(billingDayValue ) => {
          setValue('billingDay', billingDayValue);
        }}
        value={watch('billingDay')}
      >
        {({ open, value }) => (
          <>
            <Listbox.Button className={classNames('min-h-[48px] w-full cursor-pointer', { 'border border-input-error rounded-2lg': hasError })}>
              <div className="pl-7.5 flex w-full items-center justify-between py-3 pr-5">
                <div>{getBillingDayDropdownLabel(value)}</div>
                <ArrowIcon
                  className={cn({ 'text-style': open })}
                  direction={ARROW_ICON_DIRECTIONS.DOWN}
                />
              </div>
            </Listbox.Button>
            <Listbox.Options className="border-line absolute z-10 mt-1 h-44 w-full overflow-y-scroll	border">
              {billingDayOptions.map((item) => {
                return (
                  <Listbox.Option
                    value={item.value}
                    key={item.value}
                  >
                    <div
                      className="hover:bg-input cursor-pointer bg-white px-4 py-2 text-sm shadow-sm"
                    >
                      {item.label}
                    </div>
                  </Listbox.Option>
                );
              })}
            </Listbox.Options>
          </>
        )}
      </Listbox>
      {hasError && <ErrorLabel {...{ errorMessage }}/>}
    </div>
  );
};

function getBillingDayDropdownLabel(value: number) {
  const selectedOption = billingDayOptions.find((option) => option.value === value);

  return selectedOption?.label;
}
